import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.section`
  & {
    position: relative;
    width: 100%;
    height: auto;
  }

  .decorator-container {
    overflow: visible;
  }

  #group-31 {
    position: absolute;
    left: 0;
    bottom: 0;
    min-height: 139px;
    max-height: 476px;
    height: 15vw;
    transform: translate3d(-40%, 70%, 0);
    overflow: visible;
    z-index: 3;
  }

  #group-379-4 {
    position: absolute;
    right: 0;
    bottom: 10px;
    min-height: 139px;
    max-height: 382px;
    height: 15vw;
    transform: translate3d(55%, 60%, 0);
    overflow: visible;
  }

  .container {
    position: relative;
    margin: auto;
    padding: 53px 0 0 0;
    color: ${({ theme }) => theme.colors.secondary[900]};
  }

  .container > h1 {
    font-size: var(--fs-600);
    font-weight: 500;
    line-height: 1.67;
    margin: 30px auto;
    text-align: center;
  }

  .container > p {
    width: 100%;
    max-width: ${({ theme }) => theme.size.width[900]};
    height: auto;
    margin: auto;
    font-size: var(--fs-500);
    font-weight: 300;
    line-height: 1.67;
    margin: 0 auto 48px auto;
    text-align: center;
  }

  .list-container {
    width: 100%;
    margin: auto;
    padding: 0 0 53px 0;
  }

  .list-container > section {
    width: 100%;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: row nowrap;
  }

  .image-container {
    position: relative;
  }

  .image {
    padding: 100% 0 0 0;
  }

  .image > * {
    object-fit: cover;
    position: absolute !important;
    overflow: hidden;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    color: ${({ theme }) => theme.colors.gray[900]}66;
    max-width: 744px;
  }

  .checked-list-container {
    width: ${({ theme }) => theme.size.width[90]};
    max-width: ${({ theme }) => theme.size.width[900]};
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: column nowrap;
  }

  .checked-list-title {
    text-align: left;
    font-size: var(--fs-600);
    margin: 0 0 27px 0;
    line-height: normal;
  }

  .checked-list-title > * {
    margin: 0 !important;
  }

  .checked-list-title > span > .primary {
    position: relative;
  }

  .checked-list-title > span > .primary > svg {
    position: absolute;
    right: 0;
    top: 50%;
    height: 31px;
    transform: translate3d(calc(100% + 20px), -50%, 0);
    fill: ${({ theme }) => theme.colors.primary[400]};
  }

  .checked-list-title > span > .primary > .rectangle {
    width: 100vw;
  }

  .checked-list-title > span > .primary > .circle {
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '#group-379-4': {
          display: ['none', 'none', 'none', 'block'],
        },
        '.checked-list-title > span > .primary > svg': {
          height: ['15px', '15px', '19px', '31px'],
        },
        '.container > h1': {
          fontSize: [
            'var(--fs-500)',
            'var(--fs-500)',
            'var(--fs-570)',
            'var(--fs-600)',
          ],
        },
        '.container': {
          paddingTop: ['26px', '26px', '44px', '53px'],
          maxWidth: [
            theme.size.width[90],
            theme.size.width[90],
            theme.size.width[90],
            theme.size.width[900],
          ],
        },
        '.container > p': {
          fontSize: [
            'var(--fs-300)',
            'var(--fs-300)',
            'var(--fs-500)',
            'var(--fs-500)',
          ],
        },
        '.list-container': {
          maxWidth: ['unset', 'unset', 'unset', theme.size.width[900]],
        },
        '.list-container > section': {
          justifyContent: [
            'flex-start',
            'flex-start',
            'flex-start',
            'space-between',
          ],
          alignItems: ['stretch', 'stretch', 'stretch', 'flex-start'],
          flexFlow: [
            'column nowrap',
            'column nowrap',
            'column nowrap',
            'row nowrap',
          ],
          margin: ['0', '0', '0', 'auto'],
        },
        '.image': {
          paddingTop: ['61.71%', '61.71%', '61.71%', '100%'],
        },
        '.image-container': {
          width: ['100vw', '100vw', '100vw', '40%'],
        },
        '.image > *': {
          width: [
            '100% !important',
            '100% !important',
            '100% !important',
            '110% !important',
            '160% !important',
          ],
          maxWidth: ['100%', '100%', '100%', '744px'],
          height: [
            '100%',
            '100%',
            '100%',
            'calc(110% * 0.6171)',
            'calc(160% * 0.6171)',
          ],
          boxShadow: ['none', 'none', 'none', '6px 6px 16px 0 currentColor'],
          borderRadius: ['0', '0', '0', '32px 32px 0 32px'],
          left: ['0', '0', '0', 'unset !important'],
        },
        '.checked-list-container': {
          maxWidth: [
            theme.size.width[90],
            theme.size.width[90],
            theme.size.width[90],
            '60%',
          ],
          margin: [
            '52px auto 0 auto',
            '52px auto 0 auto',
            '52px auto 0 auto',
            '0 0 0 32px',
          ],
        },
        '.checked-list-title': {
          fontSize: [
            'var(--fs-500)',
            'var(--fs-500)',
            'var(--fs-570)',
            'var(--fs-600)',
          ],
        },
      }),
    ).styles}}
`

export default Container
